<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout align-center justify-center row fill-height class="login">
    <DialogLoginFailed ref="dlgLoginFailed"></DialogLoginFailed>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm8 md6 lg3>
        <v-card flat>
          <img src="static/eValueRate_Logo2.png"
               height="40px"
               width="auto"
          >
          <v-card-text class="pb-0">
            <v-form>
              <v-text-field solo class="heightLogin" v-model="form.username" :label="$t('LOGIN_USERNAME_LABEL')"
                            type="text"></v-text-field>
              <v-text-field solo class="heightLogin" id="password" v-model="form.password" :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                            :label="$t('LOGIN_PASSWORD_LABEL')" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword">
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-3 pr-3 pl-3">
            <v-btn dark class="" block color="blue" @click="doLogin()"><span
              class="font-weight-bold text-none"> {{'LOGIN_SUBMIT' | translate}}</span></v-btn>
          </v-card-actions>
          <v-layout row justify-space-between>
            <div>
              <v-btn depressed small flat color="grey darken-1" class="text-none" @click="register()">
                {{'BUTT_NO_CUSTOMER' | translate}}
              </v-btn>
            </div>
            <div>

              <v-btn depressed small flat color="grey darken-1" class="text-none" @click="passwordContact()">
                {{'BUTT_FORGOT_PASSWORD' | translate}}
              </v-btn>
            </div>
          </v-layout>
          <v-layout align-end justify-end class="versionStand">
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import api from './Login.js'
import DialogLoginFailed from './../dialogs/DialogLoginFailed'

export default {
  name: 'Login',
  components: {DialogLoginFailed},
  data () {
    return {
      showPassword: false,
      version: 'noVersion',
      form: {
        username: '', // eValueRateServiceTest
        password: '' // testeValuRate1
      }
    }
  },
  methods: {
    checkPasswordExpires () {
      let credits = Vue.prototype.$api.getCredentials()
      if (credits.data && credits.data.user) {
        let d = new Date(credits.data.user.passwordExpires)
        let current = new Date()
        let diff = current.getTime() - d.getTime()
        if (diff > 0) {
          return true
        }
      }
      return false
    },
    onLoginOk (data) {
      var cmp = this
      localStorage.clear();
      api.onLoginOk(data, function () {
        if (cmp.checkPasswordExpires()) {
          cmp.$router.push('/ResetPasswordExpires')
        } else {
          cmp.$router.push('/Dashboard')
        }
      })
      Vue.prototype.storage.saveState('currencySuffix', '€')
    },
    onLoginFailed(data) {
      let errorLoginData = {
        newName: Vue.i18n.translate('LOGIN_FAILED_TITLE'),
        title: Vue.i18n.translate('DIALOG_LOGIN_FAILED_TITLE'),
        type: '',
        description: Vue.i18n.translate('LOGIN_FAILED_DESCRIPTION'),
      }
      if (data.accessGranted === 0) {
        errorLoginData = {
          newName: Vue.i18n.translate('LOGIN_FAILED_TITLE'),
          title: Vue.i18n.translate('DIALOG_LOGIN_FAILED_TITLE_WRONG_PASSWORD'),
          type: '',
          description: Vue.i18n.translate('LOGIN_FAILED_DESCRIPTION_WRONG_PASSWORD'),
        }
      } else if (data.accessGranted === 2 || data.accessGranted === 4) {
        errorLoginData = {
          newName: Vue.i18n.translate('LOGIN_FAILED_TITLE'),
          title: Vue.i18n.translate('DIALOG_LOGIN_FAILED_TITLE_DISABLE'),
          type: '',
          description: Vue.i18n.translate('LOGIN_FAILED_DESCRIPTION_DISABLE'),
        }
      }
      this.$refs.dlgLoginFailed.open(errorLoginData);
    },
    passwordContact () {
      this.$router.push('/PasswordContact')
    },
    register () {
      this.$router.push('/Register')
    },
    doLogin (a) {
      Vue.prototype.$api.debug('doLogin')
      // Vue.prototype.$api.showIdle()
      Vue.credentials = {}
      api.doLogin(this.form, this.onLoginOk, this.onLoginFailed)
      return true
    },
  },
  mounted () {
    var cmp = this
    // Vue.prototype.$eventHub.$emit('OnLogin', true)
    Vue.prototype.$eventHub.$emit('OnShowLogin', true)
    Vue.prototype.$eventHub.$emit('OnShowRegister', false)
    Vue.prototype.$api.resetCredentials(this)

    this.version = Vue.config.data.VERSION
    if (Vue.config.data.IS_PROD) {
      this.form.username = ''
      this.form.password = ''
    }
    $('input').keypress(function (e) {
      if (e.which === 13) {
        cmp.doLogin()
        return false
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login/Login.vue